export const BENEFITS_REPORT_ACTION_ID = "benefits-report-action";

export const convertToPercent = (value: string) => {
  if (typeof value === "string" && value.includes(".")) {
    const number = parseFloat(value);
    if (!Number.isNaN(number)) {
      return value.includes("%") ? `${number * 100}` : `${number * 100}%`;
    }
  } else if (typeof value === "string" && !value.includes("%")) {
    return `${value}%`;
  } else if (typeof value === "number") {
    return `${value}%`;
  }
  return value; // Return the original value if no conversion is needed
};

export const facilityBenefitsInfo = {
  title:
    "You can customize facility benefits. If checked, those benefits will apply to this estimate.",
  items: [
    {
      title: "Medicare Advantage",
      info: "Patients typically owe a flat copayment for facility services. Coinsurance generally applies only to supplies and durable medical equipment (DME).",
    },
    {
      title: "Medicare",
      info: "Patients are typically responsible for both the deductible and coinsurance.",
    },
    {
      title: "Commercial",
      info: "All cost-sharing elements—copayments, deductibles, and coinsurance—typically apply.",
    },
  ],
};

export const professionalBenefitsInfo = {
  title:
    "You can customize professional benefits. If checked, those benefits will apply to this estimate.",
  items: [
    {
      title: "Medicare Advantage",
      info: "Patients typically owe the deductible, if applicable, for professional services. Coinsurance generally applies only to supplies and durable medical equipment (DME).",
    },
    {
      title: "Medicare",
      info: "Patients are typically responsible for both the deductible and coinsurance.",
    },
    {
      title: "Commercial",
      info: "All cost-sharing elements—copayments, deductibles, and coinsurance—typically apply.",
    },
  ],
};
